<template>
  <div class="courseware-manage">
    <div class="top-tabs">
      <mk-tabs-biz
        v-model="activeName"
        class="el-tabs-mk-ui"
      >
        <mk-tab-pane
          v-for="(item, index) in tabs"
          :key="index"
          :label="item.label"
          :name="item.name"
        >
        </mk-tab-pane>
      </mk-tabs-biz>
    </div>
    <div class="main-content">
      <component :is="activeName"></component>
    </div>
  </div>
</template>

<script>
import Pictures from './components/material-image'
import Videos from './components/material-video'
import Files from './components/material-file'
export default {
  name: 'CoursewareManage',
  components: {
    Pictures,
    Videos,
    Files
  },
  data () {
    return {
      // 当前tab名
      activeName: 'files',
      tabs: [
        {
          label: '文件',
          name: 'files'
        },
        {
          label: '视频',
          name: 'videos'
        },
        {
          label: '图片',
          name: 'pictures'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.courseware-manage {
  height: 100%;
  display: flex;
  flex-direction: column;

  // /deep/ .el-tabs__nav-scroll {
  //   .el-tabs__item {
  //     font-size: 16px;
  //     height: 60px;
  //     line-height: 60px;
  //     padding: 0 30px;
  //     font-weight: 500;
  //   }

  //   .el-tabs__item.is-active {
  //     color: #009cff !important;
  //   }

  //   .el-tabs__active-bar {
  //     background: #009cff !important;
  //   }
  // }

  // /deep/ .el-tabs__active-bar {
  //   padding: 0 10px;
  //   margin-left: -10px;
  // }

  // /deep/ .el-tabs__nav-wrap {
  //   padding: 0 !important;
  // }

  .main-content {
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.courseware-manage-popover {
  height: 40px;
  line-height: 40px;
  padding: 0 19px 0 16px;

  .mention-text {
    font-size: 13px;
    color: #595959;

    .icon-ds-tishi {
      font-size: 14px;
      color: #faad14;
      margin-right: 8px;
    }
  }
}

.courseware-manage-delete-confirm {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-ds-tishi {
      font-size: 14px;
      color: #faad14;
      margin-right: 8px;
    }
  }

  .button {
    margin-top: 12px;
    text-align: right;
  }
}

.courseware-manage-tooltip {
  background-color: rgba(0, 0, 0, 0.75) !important;
  border-color: rgba(0, 0, 0, 0.75) !important;
  color: #fff !important;

  .popper__arrow {
    border-top-color: rgba(0, 0, 0, 0.75) !important;
  }

  .popper__arrow::after {
    border-top-color: rgba(0, 0, 0, 0.75) !important;
  }
}
</style>
